import { KnowledgebasePage, SupportPage } from './index'
import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard, RequiresUsertypesGuard } from './../../shared/router/guards'
import SUPPORT_USERTYPES from './../../constants/support-access.constants'

export default [
  RouteFactory.create(KnowledgebasePage, '/kb-support', [new RequiresAuthGuard(true)], {
    name: 'Knowledgebase',
  }),
  RouteFactory.create(
    SupportPage,
    '/help-support',
    [new RequiresAuthGuard(true), new RequiresUsertypesGuard(SUPPORT_USERTYPES)],
    {
      name: 'Help & Support',
    }
  ),
]
